import React from 'react';
import '../styles/SimplePage.css';
import useSafeBack from '../hooks/useSafeBack';

function Billing() {
  const safeBack = useSafeBack();

  return (
    <div className="sa-page">
      <div className="sa-container">
        <div className="simple-page__header">
          <button className="simple-page__back" onClick={safeBack} aria-label="Go back">
            ←
          </button>
          <div>
            <h1 className="simple-page__title">Billing &amp; Payment</h1>
            <p className="simple-page__subtitle">Manage your payment method and invoices.</p>
          </div>
        </div>

        <div className="sa-card simple-page__card">
          <div className="simple-page__row">
            <div>
              <div className="simple-page__label">Current plan</div>
              <div className="simple-page__value">Free (placeholder)</div>
            </div>
            <button className="sa-btn sa-btn--primary" onClick={() => alert('Upgrade (next step)')}>
              Upgrade
            </button>
          </div>

          <div className="simple-page__divider" />

          <div className="simple-page__row">
            <div>
              <div className="simple-page__label">Payment method</div>
              <div className="simple-page__value">Not set</div>
            </div>
            <button className="sa-btn" onClick={() => alert('Add payment method (next step)')}>
              Add method
            </button>
          </div>

          <div className="simple-page__divider" />

          <div>
            <div className="simple-page__label">Invoices</div>
            <div className="simple-page__value">No invoices yet.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Billing;

